import {MyProxy} from '../../types/proxy';
const myProxy = Proxy as typeof MyProxy;
export default myProxy;